export var Cursor;
(function (Cursor) {
    Cursor["Default"] = "";
    Cursor["Move"] = "move";
    Cursor["Grabbing"] = "grabbing";
    Cursor["NESWResize"] = "nesw-resize";
    Cursor["NWSEResize"] = "nwse-resize";
})(Cursor || (Cursor = {}));
export var EditMode;
(function (EditMode) {
    EditMode["Move"] = "move";
    EditMode["Transform"] = "transform";
})(EditMode || (EditMode = {}));
export var Visibility;
(function (Visibility) {
    Visibility["Visible"] = "visible";
    Visibility["None"] = "none";
})(Visibility || (Visibility = {}));
//# sourceMappingURL=types.js.map